import React from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import _ from 'lodash';
import { withLocalize } from "react-localize-redux";
import { Link } from 'react-router-dom';


import history from '../../history';
import ContainerTranslation from "../partials/ContainerTranslation";
import { InputText } from '../input/InputText.tsx'
import { SelectLabeled } from '../input/SelectLabeled.tsx';

import { SliderCheckbox } from '../input/Checkbox';
import { updateUser, fetchUser, getAutocompleteList, deleteUser } from '../../actions/user';



class UserView extends React.Component {

  constructor(props) {
    super(props);
    const { fetchUser, getAutocompleteList } = this.props;
    this.clientRole = JSON.parse(localStorage.getItem("user")).role
    fetchUser(this.props.match.params.id);
      getAutocompleteList(this.props.match.params.id);
    this.state = {
      fields : 9,
      form : {
        lastName : {value : ""},
        firstName : {value : ""},
        role : {value : ""},
        manager : {value : ""},
        country : {value : ""},
        city : {value : ""},
        gender : {value : ""},
        isIkos : {value : ""},
        isAlphaTester : {value : ""},
      },
      message : null,
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if(nextProps.message && nextProps.message === "User successfully updated!"){
      history.push('/user');
    }
    if(Object.keys(nextProps.user).length !== 0){
      let form = Object.assign({}, this.state.form);
      
      form.lastName = {value : nextProps.user.sageContent.profile.lastName, isValid: true}
      form.firstName = {value : nextProps.user.sageContent.profile.firstName, isValid: true}
      form.role = {value : nextProps.user.sageContent.role, isValid: true}
      form.country = {value : nextProps.user.sageContent.filiale.country, isValid: true}
      form.city = {value : nextProps.user.sageContent.filiale.city, isValid: true}
      form.manager = {value : _.get(nextProps.user.sageContent,"manager.sageContent.email"), isValid: true}
      form.isIkos = {value : nextProps.user.sageContent.profile.isIkos, isValid: true}
      form.gender = {value : nextProps.user.sageContent.profile.gender, isValid: true}
      form.isAlphaTester = {value : nextProps.user.sageContent.isAlphaTester, isValid: true}
      this.setState({form})
    }
  }

  componentDidUpdate(prevProps) {

    if (!this.props.user) {
      return
    }

      if (this.props.message === 'user disabled') {
        history.push('/user/');
    }
  }

    handleInputChange(obj, bool) {
      
        let form = Object.assign({}, this.state.form);
        form[obj.name] = {value : obj.value, isValid : bool};
        this.setState({ form })


    if(this.state.message !== ""){
      this.setState({message : ""})
    }

    }

    handleInputChangeFactory(field) {

        const handleInputChange = function(obj, bool) {
            let form = Object.assign({}, this.state.form);
            form[field] = { value: obj.value, isValid: bool };
            this.setState({ form })


            if (this.state.message !== "") {
                this.setState({ message: "" })
            }

        }

        return handleInputChange.bind(this)
    }

  handleInputTextChange(obj, bool){
    
    let form = Object.assign({},this.state.form);
    
    form[obj.target.name] = {value : obj.target.value, isValid : bool};
    this.setState({form : form})

    if(this.state.message !== ""){
      this.setState({message : ""})
    }

  }

  updateUser = () => {
    const { form, fields } = this.state;
  
    const formFields = Object.keys(form);
    const isFormValid = formFields.length === fields;
  
    if (isFormValid) {
      const updatedUser = formFields.reduce((acc, key) => {
        acc[key] = form[key].value;
        return acc;
      }, {});
      this.props.updateUser(updatedUser, this.props.user._id);
    } else {
      this.setState({ message: "Le formulaire n'est pas correctement rempli" });
    }
  }

  deleteUser = () => {
      this.props.deleteUser(this.props.user._id);
  }

  
  render() {

    if ((Object.keys(this.props.user).length === 0 || Object.keys(this.props.list).length === 0)) {
      return null
    }

    const classMale = this.state.form.gender.value === 'Male' ? " selected" : "";
    const classFemale = this.state.form.gender.value === 'Female' ? " selected" : "";
    
    let alt, src
    switch (this.props.user.group){
      case "ikos":
        alt = "IKOS Logo";
        src = "https://www.nuclearvalley.com/media/cache/resolve/medium/entreprises/logos/16636_47cab734d6e161e0d9cdfc7cf6a89830.png"
        break;
      case "aegis":
        alt = "Aegis Logo";
        src = "https://aegiscertification.com/wp-content/uploads/2023/03/cropped-ACE-Logo-1-1.png"
        break;
      case "airtren":
        alt = "Airtren Logo";
        src = "https://airtren.com/wp-content/uploads/2018/12/cropped-cropped-4-2.png"
        break;
      case "bps":
        alt = "BPS Logo";
        src = "//www.bpsitalia.it/public/wp-content/uploads/2017/07/logo-sito-bps.png"
        break;
      case "alcapem":
        alt = "Alcapem Logo";
        src = "data:image/png;base64,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"
        break;
      default: 
        alt = "IKOS Logo";
        src = "https://www.nuclearvalley.com/media/cache/resolve/medium/entreprises/logos/16636_47cab734d6e161e0d9cdfc7cf6a89830.png"
    }
    
    return (
      <div className="register" style={{paddingBottom:'100px', paddingTop:'50px'}}>
        <div className="col-2">
          <div className="button-bar">
            <h1 style={{display:"inline"}}>Edit user</h1>
            <button className="view-btn" onClick={this.deleteUser.bind(this)}>Desactivate user</button>
          </div>
          <p>
            <span>Email : {this.props.user.sageContent.email}</span>
          </p>
          <div className="form-container">
            {this.state.message !== '' ?
              <p className="warning">{this.state.message}</p> : null
            }
            {this.props.user ?
              <form className="form-auth">
                <div className={"formulaire-field tabs button-bar"} style={{border:"none", paddingLeft:"20px", paddingTop:"20px"}}>
                  <div style={{display:"inline"}}>
                    <div
                      className={"formulaire-field tab" + classMale}
                      style={{ width: 'auto' }}
                      onClick={this.handleInputChange.bind(this, { name: "gender", value: "Male" }, true, false)}
                    >
                      <i className="fas fa-male" style={{ marginRight: "10px" }}></i><ContainerTranslation id={['content'] + "." + ['information-consultant'] + "." + ['gender'] + ".male"} />
                    </div>
                    <div
                      className={"formulaire-field tab" + classFemale}
                      style={{ width: 'auto' }}
                      onClick={this.handleInputChange.bind(this, { name: "gender", value: "Female" }, true, false)}
                    >
                      <i className="fas fa-female" style={{ marginRight: "10px" }}></i><ContainerTranslation id={['content'] + "." + ['information-consultant'] + "." + ['gender'] + ".female"} />
                    </div>
                  </div>
                  <img
                        className="group-icon"
                        alt={alt}
                        src={src}
                  />
                </div>
                <InputText
                  onChange={this.handleInputTextChange.bind(this)}
                  value={this.state.form.lastName.value}
                  name={'lastName'}
                  isRequired={false}
                  placeholder={this.props.translate('Page.CreateUser.Placeholder.name')} 
                  label={{title : this.props.translate("user.Name.title")}}
                />
                <InputText
                  onChange={this.handleInputTextChange.bind(this)}
                  value={this.state.form.firstName.value}
                  name={'firstName'}
                  isRequired={false}
                  placeholder={this.props.translate('Page.CreateUser.Placeholder.firstName')} 
                  label={{title : this.props.translate("user.First Name.title")}}
                />
                  {
                                this.props.user.authorization.create ?
                                    <SelectLabeled
                                        label={{ title: this.props.translate("user.Role.title") }}
                                        value={{ value: this.state.form.role.value, label: this.state.form.role.value }}
                                        onChange={this.handleInputChangeFactory('role')}
                                        options={this.props.list.roles.map((x) => { return {value : x, label : x} })}
                                    />
                    :
                    <div className="input-container">
                      <label>
                        <span>
                          Role
                        </span>
                      </label>
                      {this.state.form.role.value}
                    </div>

                  }
                            <SelectLabeled
                                label={{ title: this.props.translate("user.Country.title") }}
                                value={{ value: this.state.form.country.value, label: this.state.form.country.value }}
                                onChange={this.handleInputChangeFactory('country')}
                                options={this.props.list.countries.map((x) => { return { value: x, label: x } })}
                            />
                            {this.state.form.country.value ?
                                <SelectLabeled
                                    label={{ title: this.props.translate("user.City.title") }}
                                    value={{ value: this.state.form.city.value, label: this.state.form.city.value }}
                                    onChange={this.handleInputChangeFactory('city')}
                                    options={this.props.list.offices[this.state.form.country.value].map((x) => { return { value: x, label: x } })}
                                />
                  : null
                            }
                            <SelectLabeled
                                label={{ title: this.props.translate("user.Manager.title") }}
                                value={{ value: this.state.form.manager.value, label: this.state.form.manager.value }}
                                onChange={this.handleInputChangeFactory('manager')}
                                options={this.props.list.managers.map((x) => { return { value: x, label: x } })}
                            />
                {this.clientRole === "SuperAdmin" ? 
                  <div className="input-container">
                    <label className="required">
                      <span>{this.state.form.isAlphaTester.value ? "Demote to normal user" : "Promote to alpha tester"}</span>
                    </label>
                    <SliderCheckbox
                          style={{display:"inline-block",height:"auto"}}
                          label={this.state.form.isAlphaTester.value ? "Demote to normal user" : "Promote to alpha tester"}
                          onClick={() => this.setState({form : {...this.state.form, isAlphaTester : {value : !this.state.form.isAlphaTester.value, isValid: true}}})}
                          checked={this.state.form.isAlphaTester.value}
                    />
                  </div> : null
                }
              </form>
              : null
            }
          </div>
          <div className="button-bar">
            <button className="view-btn" onClick={this.updateUser.bind(this)}>Valider</button>
            <Link to="/user"><button className="secondary-btn">Back to the list of users</button></Link>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  user: state.user.user,
  list : state.user.list,
  message: state.user.message
})

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchUser,
  updateUser,
  deleteUser,
  getAutocompleteList
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withLocalize(UserView)));
